/* eslint-disable sort-keys-fix/sort-keys-fix */
module.exports = {
  content: [
    './src/pages/**/*.{js,ts,jsx,tsx}',
    './src/app/**/*.{js,ts,jsx,tsx}',
    './src/components/**/*.{js,ts,jsx,tsx}',
    './src/features/**/*.{js,ts,jsx,tsx}',
    './src/**/*.{js,jsx,ts,tsx}',
  ],
  darkMode: 'class',
  mode: 'jit',
  plugins: [
    // eslint-disable-next-line global-require
    require('tailwind-scrollbar-hide'),
    // eslint-disable-next-line import/no-extraneous-dependencies, global-require
    require('@tailwindcss/typography'),
    require('@tailwindcss/container-queries'),
  ],
  theme: {
    extend: {
      animation: {
        'ticker-up':
          'rotate-y-up 0.3s  ease-in-out, change-text-color-to-green 1.5s ease-in-out 0.15s',
        'ticker-down':
          'rotate-y-down 0.3s  ease-in-out, change-text-color-to-green 1.5s ease-in-out 0.15s',
        'slide-left': 'slide-left 0.3s',
        'slide-right': 'slide-right 0.3s',
      },
      keyframes: {
        'rotate-y-up': {
          '0%': {
            transform: 'translateY(0px)',
            opacity: 1,
          },
          '50%': {
            transform: 'translateY(-50px)',
            opacity: 0,
          },
          '100%': {
            transform: 'translateY(0px)',
            opacity: 1,
          },
        },
        'rotate-y-down': {
          '0%': {
            transform: 'translateY(0px)',
            opacity: 1,
          },
          '50%': {
            transform: 'translateY(50px)',
            opacity: 0,
          },
          '100%': {
            transform: 'translateY(0px)',
            opacity: 1,
          },
        },
        'change-text-color-to-green': {
          '0%': {
            color: '#5CB670',
          },
          '100%': {},
        },
        'slide-left': {
          '0%': {
            transform: 'translateX(100%)',
          },
          '100%': {
            transform: 'translateX(0%)',
          },
        },
        'slide-right': {
          '0%': {
            transform: 'translateX(-100%)',
          },
          '100%': {
            transform: 'translateX(0%)',
          },
        },
      },
      opacity: {
        '15': '0.15',
        '25': '0.25',
      },
      flexBasis: {
        '1/2-4': 'calc(50% - 16px)',
        '1/3-4': 'calc(33.333% - 16px)',
      },
      backgroundImage: () => ({
        'topo-lines': 'url(/img/topo-lines.png)',
        'topo-lines-2': 'url(/img/landing-page/background.png)',
        'striped-pattern': 'url(/img/striped_pattern.png)',
        'diagnal-pattern': 'url(/img/diagnal_pattern.svg)',
      }),
      borderColor: {
        selection: '#898989',
        unselected: '#525252',
      },
      borderWidth: {
        '1': '1px',
      },
      boxShadow: {
        // Tailwind breaks if this is in an object or some reason
        'elevation-1': '0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
        'elevation-2':
          '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
        'elevation-3':
          '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.30)',
        'elevation-4':
          '0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px 0px rgba(0, 0, 0, 0.30)',
        'elevation-5':
          '0px 8px 12px 6px rgba(0, 0, 0, 0.08), 0px 4px 4px 0px rgba(0, 0, 0, 0.08)',
        card: '0px 0px 20px rgba(61, 61, 61, 0.05)',
        'contact-us': '0px 6px 24px rgba(94, 94, 94, 0.2)',
        footer: '0px -2px 4px 0px #5E5E5E1A',
        layers: '6px 0px 24px rgba(94, 94, 94, 0.2)',
        menu: '6px 6px 24px rgba(94, 94, 94, 0.2)',
        north: ' 0px 2px 4px 0px #5353531A',
        toast: '0px 12px 24px rgba(94, 94, 94, 0.25)',
        button: '0px 2px 4px rgba(83, 83, 83, 0.1)',
        'button-hover': '0px 3px 6px rgba(94, 94, 94, 0.2)',
        'table-active': 'inset 0px 0px 0px 1px #185EC7',
      },
      // Note - we can add the background+opacities here when darkmode work starts
      backgroundColor: {
        white: '#ffffff',
        black: '#000000',
        // Can't use until we get rid of old buttons
        // primary: '#2E7A56',
      },
      colors: {
        /** Black */
        black: {
          DEFAULT: '#000',
        },
        /** Blue */
        blue: {
          light: {
            DEFAULT: '#659AF8',
            20: '#D1E1FD',
            30: '#C1D7FC',
          },
          utility: {
            DEFAULT: '#1B69DE',
            20: '#D1E1F8',
            30: '#BBD2F5',
          },
          60: '#1B69DE',
          70: '#1554B2',
          80: '#103E84',
        },
        /** Gray */
        gray: {
          ghost: {
            // todo: Revisit these -- Do not use
            active: '#87919C50',
            selected: '#87919C20',
          },
          10: '#F2F4F5',
          20: '#DCE1E5',
          30: '#C2C9CF',
          40: '#A7AFB8',
          50: '#87919C',
          60: '#64707A',
          70: '#48535C',
          80: '#343D45',
          90: '#20272E',
          100: '#12171C',
          background: '#F8F8F8',
        },
        /** Green */
        green: {
          utility: {
            DEFAULT: '#449C69',
            20: '#DAEBE1',
            30: '#C7E1D2',
          },
          30: '#70C29B',
          40: '#3FA675',
          50: '#2E7A56',
          60: '#235C45',
          70: '#1C4232',
          80: '#122B20',
        },
        /** Jade */
        jade: {
          DEFAULT: '#00FFC2',
        },
        /** Purple */
        purple: {
          utility: {
            DEFAULT: '#4421AA',
            20: '#DAD3EE',
            30: '#C7BCE5',
          },
        },
        /** Orange */
        orange: {
          utility: {
            DEFAULT: '#EB672A',
            20: '#FBE1D4',
            30: '#F9D1BF',
          },
        },
        /** Yellow */
        yellow: {
          utility: {
            DEFAULT: '#F2C216',
            20: '#FCF3D0',
            30: '#FBEDB9',
          },
        },
        /** Red */
        red: {
          utility: {
            DEFAULT: '#D91F11',
            20: '#F7D2CF',
            30: '#F4BCB8',
          },
        },
        /** White */
        white: {
          DEFAULT: '#ffffff',
        },
        /* ********* FEATURE SPECIFIC ********* */
        'customize-swatch': {
          red: '#FF2300',
          orange: '#FF9200',
          yellow: '#FFF600',
          green: '#00FF9B',
          blue: '#009FFF',
          pink: '#DA00FF',
          black: '#000000',
          white: '#ffffff',
          none: 'transparent',
        },
        'customize-hover-swatch': {
          orange: '#EB672A',
          red: '#D91F11',
          yellow: '#F2C216',
          green: '#00D481',
          blue: '#1B69DE',
          pink: '#B700D6',
          black: '#20272E',
          white: '#F2F4F5',
          none: 'transparent',
        },
        listings: {
          auction: '#6A6365',
          available: '#00FFC2',
          'sale-pending': '#FFC700',
          sold: '#FF5B82',
        },
        saved: {
          selections: '#FC00E3',
        },
        'sold-land': {
          private: '#1B69DE',
          contributory: '#449C69',
          courthouse: '#F2C216',
          curated: '#8A3FFC',
          'acre-trader': '#90BE6D',
          auction: '#885EFF',
          reject: '#CE2713',
          sales: '#9FE2FF',
        },
        mortgage: {
          FHA: '#1B69DE',
          PPL: '#8A3FFC',
          SBA: '#449C69',
        },
        timber: {
          gray: '#555555',
        },

        /* ********* LEGACY COLORS TO PHASE OUT ********* */
        primary: {
          DEFAULT: '#DED89D',
          active: '#DBD497', /// btn input
          dark: '#D2CEA4', // btn
          hover: '#E8E2AC', // btn input
          shades: {
            // btn btn-secondary
            dark: {
              yellow: {
                3: '#FFFEF6',
              },
            },
            light: {
              yellow: {
                3: '#FFFAC9',
              },
            },
          },
          yellow: {
            DEFAULT: '#EDE7AD', // btn announcements
            disabled: '#EDEACC', // btn
          },
        },
        secondary: {
          // old secondary button - see old customized-land
          DEFAULT: '#FBFBFB',
          active: '#F6F5EB',
          hover: '#FDFBE9',
        },
      },
      divideColor: {
        darkText: '#707070',
      },
      fontSize: {
        xxs: ['12px', '22px'],
        xs: ['14px', '22px'],
        sm: ['16px', '24px'],
        base: ['20px', '30px'],
        h2: ['26px', '34px'],
        lg: ['36px', '42px'],
        h1: ['36px', '42px'],
        xl: ['36px', '42px'],
        xl2: ['48px', '58px'],
        xl3: ['60px', '72px'],
      },
      height: {
        100: '488px',
        104: '512px',
        108: '576px',
        112: '640px',
        116: '704px',
        120: '768px',
        124: '832px',
        126: '896px',
        fit: 'fit-content',
        platMapOld: 'calc(100vh - 40px)',
        platMap: '100vh',
        platMapNav: '40px', // Tie this to h & max-h platMap variables
      },
      margin: {
        '18': '4.5rem',
      },
      maxHeight: {
        120: '60vh',
        platMap: '100vh',
        platMapOld: 'calc(100vh - 40px)',
      },
      minHeight: {
        0: '0',
        '1/2': '50%',
        '1/4': '25%',
        '20': '5rem',
        '212.5': '850px',
        '3/4': '75%',
        32: '8rem',
        full: '100%',
      },
      containers: {
        // dont move this!!!!, tailwind will override screen sizes by the order of them in this list
        sm: '576px',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        md: '768px',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        lg: '992px',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        '2xl': '1200px',
        '3xl': '1440px',
        shortboi: { raw: '(max-height: 360px)' },
      },
      screens: {
        // dont move this!!!!, tailwind will override screen sizes by the order of them in this list
        sm: '576px',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        md: '768px',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        lg: '992px',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        '2xl': '1200px',
        '3xl': '1440px',
        shortboi: { raw: '(max-height: 360px)' },
      },
      transitionProperty: {
        spacing: ['margin', 'padding'],
        width: 'width',
        height: 'height',
      },
      width: {
        '100': '25rem',
        '112': '34rem',
        '18': '4.5rem',
        '210': '52.5rem',
        '30': '7.5rem',
      },
      zIndex: {
        '60': 60,
        '70': 70,
        '80': 80,
      },
    },
  },
  variants: {
    extend: {
      backgroundColor: ['disabled', 'active'],
      borderColor: ['active'],
      borderRadius: ['last', 'first'],
      cursor: ['disabled'],
      opacity: ['disabled'],
    },
  },
};
